import { Link } from "react-router-dom";
import { FaRegBuilding, FaChevronRight, FaPills } from "react-icons/fa";
import { RiMedicineBottleLine } from "react-icons/ri";
import { MdCategory, MdCompareArrows } from "react-icons/md";
import { useCompare } from "../../hooks/useCompare";

export default function TradenameListCell({ item, isLastItem, lastItemRef }) {
    const { isSelected, toggleItem, isFull } = useCompare();
    const selected = isSelected(item.uri);
    const disabled = !selected && isFull;

    const handleCompareToggle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (disabled) return;
        toggleItem(item);
    };

    return (
        <Link
            key={item._id}
            ref={isLastItem ? lastItemRef : null}
            to={`/tradenames/${item.uri}`}
            className={`block overflow-hidden transition-all duration-200 border bg-white/40 backdrop-blur-sm border-white/60 group rounded-xl hover:shadow-md focus:outline-none focus:ring-2 focus:ring-primary/30 ${selected ? 'ring-2 ring-primary/30 border-primary/30' : ''}`}
        >
            <div className="flex items-center p-3 relative">
                <div className="flex-shrink-0 mr-4">
                    <div className="flex items-center justify-center transition-colors rounded-full w-11 h-11 bg-primary/10 text-primary group-hover:bg-primary/20">
                        <RiMedicineBottleLine className="size-5" />
                    </div>
                </div>
                <div className="flex-1 min-w-0">
                    <div className="font-medium transition-colors text-16 text-secondary group-hover:text-primary">
                        {item.name.replace("&amp;", "&")}
                    </div>
                    <div className="flex items-center gap-4 mt-1.5 text-14 text-secondary/70">
                        <div className="flex items-center gap-1.5">
                            <FaRegBuilding className="size-3.5 text-secondary/60" />
                            <span>{item.manufacturers[0]?.name || 'Unknown Manufacturer'}</span>
                        </div>
                        {item.forms?.[0]?.[0] && (
                            <div className="flex items-center gap-1.5">
                                <FaPills className="size-3.5 text-secondary/60" />
                                <span>{item.forms[0][0]}</span>
                            </div>
                        )}
                        {item.categories?.length > 0 && (
                            <div className="flex items-center gap-1.5">
                                <MdCategory className="size-3.5 text-secondary/60" />
                                <span>{item.categories.length} {item.categories.length === 1 ? 'category' : 'categories'}</span>
                            </div>
                        )}
                    </div>
                </div>

                {/* Compare button */}
                <button
                    onClick={handleCompareToggle}
                    className={`flex-shrink-0 flex items-center justify-center size-9 rounded-lg transition-all mr-2 ${selected
                        ? 'bg-primary text-white shadow-sm'
                        : disabled
                            ? 'bg-secondary/5 text-secondary/20 cursor-not-allowed'
                            : 'bg-white/90 text-secondary/60 hover:text-primary hover:bg-primary/10 border border-secondary/10'
                        }`}
                    aria-label={selected ? `Remove ${item.name} from comparison` : `Add ${item.name} to comparison`}
                    title={disabled ? "Maximum 4 items selected" : selected ? "Remove from comparison" : "Add to comparison"}
                >
                    <MdCompareArrows className="size-4" />
                </button>

                <div className="flex-shrink-0 transition-transform transform group-hover:translate-x-1">
                    <div className="p-2 rounded-full text-secondary/40 group-hover:text-primary">
                        <FaChevronRight className="size-4" />
                    </div>
                </div>
            </div>
        </Link>
    );
}
